module.exports = __webpack_public_path__ + "static/media/early-learning.f8d2bb1b.png";